app.portfolioController = app.portfolioController || {};

app.portfolioController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.masonry();
        this.projectHover();
    },
    
    masonry : function () {
        var $portfolio = $('.portfolioList').imagesLoaded( function() {
            $portfolio.masonry({
                // options
                itemSelector: '.portfolioList > li',
                columnWidth: '.portfolioList > li',
                percentPosition: true
            });
        });
    },
    
    projectHover : function () {
        var $project = $('.shortPortfolioItem:not(.other)');
        if ($project.length > 0) {
            if ($('html').hasClass('touch')) {
                $project.each(function() {
                    $item = $(this);
                    $itemLink = $item.find('.itemLink');
                    $item.find('.itemDetails').append('<a href="'+$itemLink.attr('href')+'" class="itemTouchLink">Voir</a>');
                    $itemLink.replaceWith('<div class="itemLink">'+$itemLink.html()+'</div>');
                });
            }
        }
    },

};